import {
  ADMIN_PANEL_SECTION_CONFIG_FE_KEYS,
  ADMIN_PANEL_SECTION_CONFIG_FE_STATUS,
} from "features/AdminPanel/constants/AdminPanel.constants";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";

export const useSavingStatus = () => {
  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const setSectionConfig = useAdminPanelStore(
    (state) => state.setSectionConfig
  );

  const setSaving = ({ featureKey }) => {
    setSectionConfig({
      [featureKey]: {
        ...sectionConfig[featureKey],
        [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.FE_METADATA]: {
          [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.UPDATION_STATUS]: {
            [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.STATUS]:
              ADMIN_PANEL_SECTION_CONFIG_FE_STATUS.SAVING,
          },
        },
      },
    });
  };

  const setSaved = ({ featureKey }) => {
    setSectionConfig({
      [featureKey]: {
        ...sectionConfig[featureKey],
        [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.FE_METADATA]: {
          [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.UPDATION_STATUS]: {
            [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.STATUS]:
              ADMIN_PANEL_SECTION_CONFIG_FE_STATUS.SAVED,
          },
        },
      },
    });
  };

  const setErrorStatus = ({ featureKey }) => {
    setSectionConfig({
      [featureKey]: {
        ...sectionConfig[featureKey],
        [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.FE_METADATA]: {
          [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.UPDATION_STATUS]: {
            [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.STATUS]:
              ADMIN_PANEL_SECTION_CONFIG_FE_STATUS.ERROR,
          },
        },
      },
    });
  };

  const hideStatus = ({ featureKey }) => {
    setSectionConfig({
      [featureKey]: {
        ...sectionConfig[featureKey],
        [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.FE_METADATA]: undefined,
      },
    });
  };

  return { setSaving, setSaved, setErrorStatus, hideStatus };
};
